<template>
  <div
    @click="selected"
    class="multimedia__content-grid-item"
    role="button">
    <img
      v-if="hasThumbnail"
      v-lazy="thumbnail"
      class="multimedia__content-grid-image"/>
    <div
      v-else
      class="multimedia__content-grid-background"></div>
    <div class="multimedia__content-grid-button">
      <play-icon class="multimedia__content-grid-button-icon"/>
    </div>
    <div class="multimedia__content-grid-footer">
      <div class="multimedia__content-grid-footer-text">{{ filename }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PlayIcon from '@/assets/icons/play.svg';

export default {
  components: {
    PlayIcon,
  },
  props: {
    video: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(['token']),
    videoData() {
      return this.data ?? {};
    },
    thumbnail() {
      if (this.videoData.thumb) {
        return `${this.videoData.thumb}?token=${this.token}`;
      }
      return this.videoData.thumbnail ? `${this.videoData.thumbnail}?token=${this.token}` : '';
    },
    hasThumbnail() {
      return this.thumbnail.length > 0;
    },
    filename() {
      return this.videoData.filename ?? 'file';
    },
    data() {
      return this.video.video ?? this.video.multimedia;
    },
  },
  methods: {
    selected() {
      this.$emit('selected', this.video);
    },
  },
};
</script>
